import {
  AddUserCompanyRequest,
  Company,
  CreateCompanyRequest,
  DeleteCompanyRequest,
  RemoveUserCompanyRequest,
  UpdateCompanyRequest,
} from 'src/common-services/types/company-types'
import { User } from 'src/common-services/types/user-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class CompanyClient extends BaseClient {
  getCompanies(): Promise<Company[]> {
    return this.call<Company[]>('/companies', 'GET')
  }

  createCompany(request: CreateCompanyRequest): Promise<void> {
    return this.call<void>('/companies', 'POST', { data: request })
  }

  updateCompany(request: UpdateCompanyRequest): Promise<void> {
    return this.call<void>(`/companies/${request.id}`, 'PUT', { data: request })
  }

  deleteCompany(request: DeleteCompanyRequest): Promise<void> {
    return this.call<void>(`/companies/${request.id}`, 'DELETE')
  }

  getCompanyUsers(id: string): Promise<User[]> {
    return this.call<User[]>(`/companies/${id}/users`, 'GET')
  }

  addUserCompany(request: AddUserCompanyRequest): Promise<User[]> {
    return this.call<User[]>(`/companies/${request.id}/users`, 'POST', { data: request })
  }

  removeUserCompany(request: RemoveUserCompanyRequest): Promise<void> {
    return this.call(`/companies/${request.id}/users/${request.userId}`, 'DELETE')
  }

  getUserCompanyLogo(): Promise<string> {
    return this.call<string>(`/companies/logo/users`, 'GET')
  }
}
